import request from '@/utils/request'
import plaintextrequest from '@/utils/plaintextrequest'

//头部接口
export function getcommunityInfo(data) {
    return request({
        url: '/Comments/getginfo',
        method: 'post',
        data
    })
}

//评论分类接口
export function getCommentType(data) {
    return plaintextrequest({
        url: '/Comments/types',
        method: 'post',
        data
    })
} 
// 获取一级评论列表
export function getCommentList(data) {
    return plaintextrequest({
        url: '/Comments/get',
        method: 'post',
        data
    })
}
// 获取二级评论列表
export function getCommentList2(data) {
    return plaintextrequest({
        url: 'Comments/listscomments',
        method: 'post',
        data
    })
}
// 提交评论
export function addComment(datas) {
    // console.log('评论内容-----',datas.get('content'))
    return plaintextrequest({
        url: '/Comments/commit',
        method: 'post',
        data:datas,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
    })
}
// 社区置顶话题评论
export function stickComment(data) {
    return plaintextrequest({
      url: "/comments/committop",
      method: "post",
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
// 点赞评论
export function likeComment(data) {
    return request({
        url: '/Comments/good',
        method: 'post',
        data
    })
}

export function hideComment(data) {
    return request({
        url: '/Comments/uncheck',
        method: 'post',
        data
    })
}   


// 话题接口---------------
export function getTopicDetail(data) {
    return plaintextrequest({
        url: '/Information/dtjdetail',
        method: 'post',
        data
    })
}

//话题评论发表
export function addTopicComment(datas) {
    // console.log('话题集评论发送的数据---------',datas.get('content'))
    return plaintextrequest({
        url:'/comments/commitHtj',
        method: 'post',
        data:datas,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
    })
}

// 话题评论获取
export function getTopicComment(data){
    return plaintextrequest({
        url:'/comments/getHtj',
        method:'post',
        data
    })
}
// 往期话题
export function getTopicList(data) {
    return plaintextrequest({
        url: '/Information/htjLists',
        method: 'post',
        data
    })
}

// ---------社区推荐接口

export function  getAssociationInfo(data) {
    return plaintextrequest({
      url: "/Comments/hotcomments",
      method: "post",
      data,
    });
  }


//名人堂接口
export function mrtpaihang(data){
    return request({
      url: "/publicH5/hoardCoins",
      method: "post",
      data,
    })
  }
  
  //周活跃榜接口
  export function zhouhuoyue(data){
    return plaintextrequest({
      url: "/CommentsJuhe/goldranklist",
      method: "post",
      data,
    })
  }
  
  export function getLevel(data) {
    return plaintextrequest({
      url: "/CommentsJuhe/levelinfo",
      method: "post",
      data,
    });
  }